module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.11799/assets/images/app_collections.png"